// test2040
(2040 && 0);
